import React from "react";
import { FaWhatsapp } from "react-icons/fa";

export const FloatingWA = ({ number }) => {
  if (!number) return null;
  const href = `https://wa.me/${number}?text=${encodeURIComponent("Salam, saya nak tanya tentang servis Azmiey Store.")}`;
  return (
    <a
      data-testid="floating-wa-btn"
      href={href}
      target="_blank"
      rel="noreferrer"
      className="wa-pulse fixed bottom-5 right-5 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform sm:bottom-6 sm:right-6"
      aria-label="Contact via WhatsApp"
    >
      <FaWhatsapp className="w-7 h-7" />
    </a>
  );
};

export default FloatingWA;
